import { AbstractControl, ValidationErrors } from "@angular/forms";

export function pswCharacterControl(control: AbstractControl): ValidationErrors | null {
    const expression: RegExp =  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,32}$/;
  
    return !expression.test(control.value)
      ? { passwordNotStrong: true }
      : null;
}

export function noEmailValidator(control: AbstractControl): ValidationErrors | null {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
  if (control.value && emailRegex.test(control.value)) {
    return { noEmailAllowed: true }; 
  }
  return null; 
}
